export default "__VITE_ASSET__wR3Spspw__"